export function tablePricing () {
	$('.btn-request-advise').on('click', function (e) {
		const nameProject = $(this).closest('.item-pricing').find('.pricing-title').text();
		const cateProject = $('.wrap-tab-list li.active a').text();
		Fancybox.show([{ src: '#modal-contact', type: 'inline' }]);
		$('input[name="ContactAreaString"]').val(nameProject + " " + cateProject);
	})
	$(".wrap-tab-loading li a").on("click", async function (e) {
		e.preventDefault();
		const $tabLoading = $(this).closest(".section-pricing-table").find(".wrap-tab-loading");
		const nameTab = $(this).attr("href");
		$(this).parent().addClass("active").siblings().removeClass("active");
		$tabLoading.addClass("isLoading");
		await new Promise((resolve) => setTimeout(resolve, 300));
		$(`.wrap-tab-loading ${nameTab}`).show().siblings(".wrap-pricing-content").hide().removeClass("active");
		await new Promise((resolve) => setTimeout(resolve, 300));
		$tabLoading.removeClass("isLoading");
		$(`.wrap-tab-loading ${nameTab}`).addClass("active");
		return false;
	});
}